import React, { FormEvent, useContext, useState, JSX } from 'react';
import { WorkflowContext } from "../../context/WorkflowContextProvider";
import Form from '@rjsf/mui';
import { IChangeEvent } from '@rjsf/core';
import {RegistryWidgetsType, RJSFSchema, UiSchema} from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';
import { WorkflowNode, ToolOption, Workflow, Agent } from "../../../../types/workflow";
import { useReactFlow, applyNodeChanges, ReactFlowInstance } from "@xyflow/react";
import { Tool } from "../../../../types/entities";
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import { processNodeDelete, processNodeFormSubmit, formSchema, nodeDescription } from "./functions/workflow-loop-node-configuration";
import { PromptTemplateFormWidget } from "./components/PromptTemplateFormWidget";
import { LLMModelWidget } from "./components/LLMModelWidget";
import { DefaultFormDialog  } from "./components/DefaultFormDialog";
import { NodeDataStoreSelectWidget } from "./components/NodeDataStoreSelectWidget";
import {
    Button
} from '@mui/material';

export const WorkflowLoopNodeConfiguration: () => JSX.Element = (): JSX.Element => {
    const context: any = useContext(WorkflowContext);
    const reactFlowInstance: ReactFlowInstance = useReactFlow();

    function handleCloseDialog(): void {
        context.toggleShowLoopModal(false);
    }

    const handleFormSubmit: (data: IChangeEvent, event: FormEvent<any>) => void = (data: IChangeEvent, event: FormEvent<any>) : void => {
        console.log(data.formData);
        processNodeFormSubmit(context, data.formData, reactFlowInstance);
        handleCloseDialog();
    }

    function deleteNode(): void {
        processNodeDelete(context, reactFlowInstance);
        handleCloseDialog();
    }


    const uiSchema: UiSchema = {
        'data_input': {
            'ui:widget': 'NodeDataManagementWidget',
        },
        'expected_value': {
            'ui:widget': 'textarea'
        },
        'system_prompt': {
            'ui:widget': 'PromptTemplateFormWidget'
        },
        'action_prompt': {
            'ui:widget': 'PromptTemplateFormWidget'
        },
        'llm': {
            'ui:widget': 'LLMModelWidget'
        },
        'data_management': {
            'ui:widget': 'NodeDataManagementWidget',
            'ui:options': {
                'classNames': 'data-management'
            }
        },

        // 'ui:order': [
        //     'data_input',
        //     'input_key',
        //     'allOf',
        //     'system_prompt',
        //     'action_prompt',
        //     'data_management',
        //     'evaluation',
        //     'evaluation_value',
        //     'evaluation_key',
        //     'llm_temperature',
        //     'llm'
        // ]
    }

    const widgets: RegistryWidgetsType = {
        PromptTemplateFormWidget: PromptTemplateFormWidget,
        LLMModelWidget: LLMModelWidget,
        NodeDataManagementWidget: NodeDataStoreSelectWidget
    }

    return (
        <DefaultFormDialog
            open={ context.showLoopModal }
            title={ "Loop Node Configuration" }
            handleClose={ handleCloseDialog }
            description={ nodeDescription }
        >
            <span style={ { paddingLeft: '15px', fontWeight: 'bold' } }>{ "Node ID: " + context?.activeEditLoopNode?.id }</span>
            <Form
                validator={validator}
                schema={ formSchema }
                uiSchema={ uiSchema }
                onSubmit={ handleFormSubmit }
                widgets={ widgets }
                formData={ (
                    context.activeEditLoopNode !== undefined &&
                    context.activeEditLoopNode.data !== undefined ?
                        context.activeEditLoopNode.data : undefined
                ) }
            >
                <div className="dialog__actions form-group">
                    <Button type="submit"
                            variant="contained"
                            color="success"
                    >
                        <SaveIcon />
                        <span>{ "Save" }</span>
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={ deleteNode }
                        type="button">
                        <DeleteIcon />
                        <span>{ "Delete" }</span>
                    </Button>

                </div>
            </Form>
        </DefaultFormDialog>
    );

}